import { connect } from "react-redux";

import {
  addProjectAssignee,
  deleteProjectAssignee,
  getProjectShortList,
} from "../../Projects/projectsActions";
import { updateMemberwiseTimesheetApprovalSettings } from "../../Settings/TimesheetSettings/timesheetSettingsActions";
import {
  addTeamMember,
  getTeamShortList,
  removeTeamMember,
} from "../../Teams/teamsActions";
import { profileOperation } from "../../UserProfile/userProfileActions";
// Actions
import {
  clearMemberDetailsData,
  getMemberDetails,
  getMemberMonthlyEarning,
  getMemberWeeklyEarning,
  removeMember,
  setGeofenceStatus,
  setPaymentConfiguration,
  updateMember,
  setAttendanceSelfieStatus,
} from "../membersActions";
import MemberDetails from "./MemberDetails";

// Store props to map with current state
const mapStateToProps = state => ({
  isLoading: state.member.isLoading,
  paymentConfigurationLoading: state.member.paymentConfigurationLoading,
  updateMemberLoading: state.member.updateMemberLoading,
  deleteMemberLoading: state.member.deleteMemberLoading,
  teamListIsLoading: state.team.shortListIsLoading,
  teamMemberIsLoading: state.team.teamMemberIsLoading,
  projectListIsLoading: state.project.shortListIsLoading,
  updateIsLoading: state.profile.updateIsLoading,
  profileData: state.profile.profileData,
  profileDataError: state.profile.profileDataError,
  projectAssigneeIsLoading: state.project.projectAssigneeIsLoading,
  selectedOrganization: state.organization.selectedOrganization,
  memberDetails: state.member.memberDetails,
  weeklyEarning: state.member.weeklyEarning,
  monthlyEarning: state.member.monthlyEarning,
  teamList: state.team.teamsShortList,
  projectList: state.project.projectShortList,
  profile: state.profile,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getMemberDetails: details => dispatch(getMemberDetails({ ...details })),
  getMemberWeeklyEarning: details =>
    dispatch(getMemberWeeklyEarning({ ...details })),
  getMemberMonthlyEarning: details =>
    dispatch(getMemberMonthlyEarning({ ...details })),
  clearMemberDetailsData: () => dispatch(clearMemberDetailsData()),
  getTeamShortList: details => dispatch(getTeamShortList({ ...details })),
  addTeam: details => dispatch(addTeamMember({ ...details })),
  getProjectShortList: details => dispatch(getProjectShortList({ ...details })),
  assignProject: details => dispatch(addProjectAssignee({ ...details })),
  updateMember: details => dispatch(updateMember({ ...details })),
  removeMember: details => dispatch(removeMember({ ...details })),
  setPaymentConfiguration: details =>
    dispatch(setPaymentConfiguration({ ...details })),
  profileOperation: details => dispatch(profileOperation({ ...details })),

  // settings
  updateMemberwiseTimesheetApprovalSettings: details =>
    dispatch(updateMemberwiseTimesheetApprovalSettings({ ...details })),
  //project
  deleteProjectAssignee: details =>
    dispatch(deleteProjectAssignee({ ...details })),
  // team
  removeTeamMember: details => dispatch(removeTeamMember({ ...details })),
  setGeofenceStatus: details => dispatch(setGeofenceStatus({ ...details })),
  setAttendanceSelfieStatus: details =>
    dispatch(setAttendanceSelfieStatus({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(MemberDetails);
